import { TextField, Theme } from "@material-ui/core";
import { styled } from "@material-ui/styles";

export const StyledTextField = styled(TextField)(({ theme }: { theme: Theme }) => ({
  "& .MuiInput-underline:before": {
    borderBottomColor: "black", // Semi-transparent underline
  },
  "& .MuiInput-underline:hover:before": {
    borderBottomColor: "black", // Solid underline on hover
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: theme.palette.primary.main, // Solid underline on focus
  },
})) as typeof TextField;
